module.exports = __webpack_public_path__ + "assets/img/yi_index_lpj.0efb3373.png";